export const inspirations = [
  {
    id: "ins1",
    title: "暖光下的女性",
    subtitle: "关于光与温柔的灵感合集",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20golden%20light%20editorial%20photograph%20of%20a%20woman%2C%20soft%20amber%20tones%2C%20cream%20minimal%20background%2C%20serene%20elegant%20mood%2C%20high%20detail%20art%20photography&width=1200&height=800&seq=ins-01&orientation=landscape",
    intro:
      "从晨间到黄昏，暖光是最会讲故事的滤镜。这一辑收录了以自然暖光为主线的女性影像，教你如何用柔光塑造情绪。",
    story:
      "我们邀请了三位长期拍摄女性题材的摄影师，聊了聊他们心中的「暖光」。在他们看来，暖光不只是色温，更是一种态度——它让被拍摄者放松、被接纳，让镜头里的女性敢于呈现自己最柔软的一面。本辑挑选的作品多使用逆光与侧逆光，配合低对比的后期，保留了皮肤丰富的层次。你可以试着在日落前一小时拍摄，把人物放在光与影的交界处，让暖调包裹住整幅画面。",
    curators: "专题策划 · 沈鹿 / 林晚 / 周颂",
    workIds: ["w01", "w11", "w04", "w10", "w13"],
  },
  {
    id: "ins2",
    title: "身体是语言",
    subtitle: "形体与抽象的艺术探索",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20fine%20art%20photograph%20of%20a%20woman%20body%20in%20motion%2C%20soft%20light%20and%20shadow%2C%20minimal%20cream%20background%2C%20poetic%20elegant%2C%20high%20detail&width=1200&height=800&seq=ins-02&orientation=landscape",
    intro:
      "当身体成为线条与光影，摄影便走向了抽象。本辑聚焦形体艺术，展现女性形态中的诗意与力量。",
    story:
      "形体摄影的难点在于「减法」——去掉背景、去掉装饰，只保留形与光。本辑的作品大多在极简空间中完成，摄影师通过慢门、覆盖与影棚灯光，让动作的残余轨迹被记录下来。拍摄时记住两个关键词：呼吸与延展。让模特的每一次呼吸带动身体的起伏，再用手臂与颈线去延展画面方向，抽象感自然浮现。",
    curators: "专题策划 · 沈鹿 / 周颂",
    workIds: ["w06", "w07", "w08", "w09", "w17"],
  },
  {
    id: "ins3",
    title: "日常即大片",
    subtitle: "把生活拍成时尚杂志",
    cover:
      "https://readdy.ai/api/search-image?query=candid%20lifestyle%20photograph%20of%20a%20woman%20in%20a%20warm%20cozy%20home%2C%20soft%20natural%20light%2C%20cream%20tones%2C%20authentic%20warm%20mood%2C%20high%20detail&width=1200&height=800&seq=ins-03&orientation=landscape",
    intro:
      "买菜、读书、做饭……生活里的每个瞬间都值得被认真对待。本辑教你把最普通的日常，拍出杂志般的高级质感。",
    story:
      "日常摄影最珍贵的，是「不设防」的真实。与其摆姿势，不如给被拍摄者一个具体的动作——倒一杯水、翻一页书、走向窗边。摄影师要做的，是提前找好光、算好构图，然后安静地等待那个自然流露的瞬间。本辑的所有作品都没有复杂的道具，靠的只是对光线与情绪的把控。",
    curators: "专题策划 · 苏芷 / 陈屿",
    workIds: ["w11", "w12", "w13", "w14"],
  },
  {
    id: "ins4",
    title: "想象力的边界",
    subtitle: "超现实与色彩创意实验",
    cover:
      "https://readdy.ai/api/search-image?query=surreal%20creative%20conceptual%20photograph%20with%20bold%20warm%20color%20blocks%20and%20a%20woman%2C%20dreamlike%20playful%20composition%2C%20high%20detail%20art&width=1200&height=800&seq=ins-04&orientation=landscape",
    intro:
      "如果现实太无聊，那就造一个梦。本辑收录最大胆的创意实验，用色彩与装置打开女性视觉的另一种可能。",
    story:
      "创意摄影的核心是「先想清楚再拍」。本辑的每一组作品，都从一个概念出发：漂浮、镜像、色彩碰撞……摄影师先用草图确定构图，再用纸艺、镜面、色块搭建场景。别怕夸张，大胆的暖色与错位的空间往往能带来惊喜。想象力的边界，其实取决于你敢不敢先画下那个梦。",
    curators: "专题策划 · 顾朗 / Marco",
    workIds: ["w15", "w16", "w17", "w18", "w02"],
  },
  {
    id: "ins5",
    title: "东方新语",
    subtitle: "当传统美学遇见当代女性",
    cover:
      "https://readdy.ai/api/search-image?query=east%20asian%20inspired%20warm%20toned%20editorial%20photograph%20of%20a%20woman%2C%20terracotta%20and%20cream%20palette%2C%20soft%20light%2C%20timeless%20elegance%2C%20high%20detail&width=1200&height=800&seq=ins-05&orientation=landscape",
    intro:
      "把东方的审美语境带回画面，用泥土般的暖色与克制的构图，讲述属于当代女性的从容与雅致。",
    story:
      "东方美学讲究「留白」与「气韵」。本辑的作品多以赭红、米白、土黄等大地色系为主，配合对称或极简的构图。人物不需要刻意摆出兰花指，一个淡淡的侧目、一次舒缓的抬手，就足以传达出含蓄的力量。拍摄时可以尝试大面积留白，让视线有呼吸的空间。",
    curators: "专题策划 · 周颂 / 顾朗",
    workIds: ["w10", "w03", "w09", "w04", "w05"],
  },
];